module.exports = __webpack_public_path__ + "img/accept-left-circle7.4e2f59af.svg";